// @flow
export default {
  hyperlink: {
    margin: '0px 16px 0 8px'
  },
  hyperlinkMobile: {
    margin: '0px 8px'
  }
}
